<h3>Public Holidays</h3>
<p>
  USA and South Africa public holidays are recognised automatically and listed together. When a holiday moves to a
  weekday, both the named date and the observed date are listed. Add extra non-trading dates for early bank closes,
  training days, and similar exceptions.
</p>

<div class="mb-3">
  <button
    *ngIf="!showAddForm"
    type="button"
    mdbBtn
    class="btn btn-sm btn-trakly-action"
    (click)="openAddForm()"
    [disabled]="saving"
  >
    Add extra date
  </button>

  <div *ngIf="showAddForm" class="add-form border p-3">
    <div class="form-row align-items-end">
      <div class="form-group col-md-3 mb-2">
        <label for="newHolidayDate">Date</label>
        <input
          id="newHolidayDate"
          type="date"
          class="form-control form-control-sm"
          [min]="minDate"
          [(ngModel)]="newDate"
        />
      </div>
      <div class="form-group col-md-4 mb-2">
        <label for="newHolidayName">Name (optional)</label>
        <input id="newHolidayName" type="text" class="form-control form-control-sm" [(ngModel)]="newName" maxlength="150" />
      </div>
      <div class="form-group col-md-5 mb-2">
        <span class="d-block">Applies to</span>
        <div class="form-check form-check-inline mt-2">
          <input
            id="newHolidayUsa"
            type="checkbox"
            class="form-check-input"
            [ngModel]="isNewCountrySelected('USA')"
            (ngModelChange)="setNewCountry('USA', $event)"
          />
          <label class="form-check-label" for="newHolidayUsa">USA</label>
        </div>
        <div class="form-check form-check-inline mt-2">
          <input
            id="newHolidayZa"
            type="checkbox"
            class="form-check-input"
            [ngModel]="isNewCountrySelected('ZA')"
            (ngModelChange)="setNewCountry('ZA', $event)"
          />
          <label class="form-check-label" for="newHolidayZa">South Africa</label>
        </div>
      </div>
    </div>
    <div>
      <button type="button" class="btn btn-sm btn-trakly-action mr-2" (click)="addHoliday()" [disabled]="saving || !canSaveAdd()">
        Save
      </button>
      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="cancelAdd()" [disabled]="saving">Cancel</button>
    </div>
  </div>
</div>

<div *ngIf="loading" class="mb-3">Loading…</div>

<div class="table-responsive" *ngIf="!loading">
  <table class="table" mdbTable hover="true" small="true">
    <thead>
      <tr>
        <th>Date</th>
        <th>Country</th>
        <th>Name</th>
        <th>Source</th>
        <th class="text-center">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngIf="visibleHolidays.length === 0">
        <td colspan="5">No upcoming public holidays.</td>
      </tr>
      <tr *ngFor="let holiday of visibleHolidays">
        <td>
          <span *ngIf="!editMode || editedDate !== holiday.date">{{ formatDisplayDate(holiday.date) }}</span>
          <input
            *ngIf="editMode && editedDate === holiday.date"
            type="date"
            class="form-control form-control-sm"
            [min]="minDate"
            [(ngModel)]="draftDate"
          />
        </td>
        <td>{{ countriesLabel(holiday.countries) }}</td>
        <td>
          <span *ngIf="!editMode || editedDate !== holiday.date">{{ holiday.name || '—' }}</span>
          <input
            *ngIf="editMode && editedDate === holiday.date"
            type="text"
            class="form-control form-control-sm"
            [(ngModel)]="draftName"
            maxlength="150"
          />
        </td>
        <td>{{ sourceLabel(holiday) }}</td>
        <td class="text-center">
          <span *ngIf="!isManualGroup(holiday)">Automatic</span>
          <ng-container *ngIf="isManualGroup(holiday) && (!editMode || editedDate !== holiday.date)">
            <button type="button" class="btn btn-sm btn-outline-primary mr-2" (click)="startEdit(holiday)" [disabled]="saving">
              Edit
            </button>
            <button type="button" class="btn btn-sm btn-outline-danger" (click)="deleteHoliday(holiday)" [disabled]="saving">
              Delete
            </button>
          </ng-container>
          <ng-container *ngIf="isManualGroup(holiday) && editMode && editedDate === holiday.date">
            <button type="button" class="btn btn-sm btn-trakly-action mr-2" (click)="saveEdit(holiday)" [disabled]="saving || !draftDate">
              Save
            </button>
            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="cancelEdit()" [disabled]="saving">Cancel</button>
          </ng-container>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<error-component [error]="pageError" [(showModal)]="showError"></error-component>
